export default {
    headerRow: ['Suite', 'Tenant', 'Sq Ft'],
    rows: {'no-row': {valueCells: []}}
}